import {
	EVENT_ACTION_PARKING_AVAILABILITY_SELECTED_ENTRY_DATE,
	EVENT_CATEGORY_PARKING_AVAILABILITY,
	trackCustomEvent,
} from '../../../../../../shared/analytics';

export function trackSelectedEntryDate(entryDate: string) {
	trackCustomEvent({
		category: EVENT_CATEGORY_PARKING_AVAILABILITY,
		action: EVENT_ACTION_PARKING_AVAILABILITY_SELECTED_ENTRY_DATE,
		label: entryDate,
	});
}
